import { cn } from "../../../../../utils/helpers";
import CaseloadAndCalendarWrapper from "../CaseloadAndCalendarWrapper/CaseloadAndCalendarWrapper";
import ProvidersPendingTasks from "../ProvidersPendingTasks/ProvidersPendingTasks";
import UpcomingAppointments from "../UpcomingAppointments/UpcomingAppointments";

// min-[1250px]:flex-row gap-x-24 min-[1250px]:*:basis-1/2

export default function Overview() {
    return (
        <div>
            <div
                className={cn(
                    "flex gap-[--spacing-items] flex-col min-[1250px]:flex-row min-[1250px]:*:basis-1/2 relative"
                )}
            >
                <UpcomingAppointments />
                <ProvidersPendingTasks />
            </div>
            <div className="mt-[--spacing-sections]">
                <CaseloadAndCalendarWrapper />
            </div>
        </div>
    );
}
